import React from "react";

const TablePagination = ({
  currentPage,
  setCurrentPage,
  totalPages,
  itemsPerPage,
  totalRecords,
}) => {
  const start = (currentPage - 1) * itemsPerPage + 1;
  const end = Math.min(currentPage * itemsPerPage, totalRecords);

  return (
    <div className="table-footer">
      <p className="mb-0 f-s-15 f-w-500 txt-ellipsis-1">
        Showing {start} to {end} of {totalRecords} entries
      </p>

      <ul className="pagination app-pagination justify-content-end">
        {/* Previous button */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link b-r-left"
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
        </li>

        {/* Page numbers */}
        {(() => {
          const getPageNumbers = () => {
            if (totalPages <= 7) {
              return [...Array(totalPages)].map((_, i) => i + 1);
            }
            if (currentPage <= 3) {
              return [1, 2, 3, 4, 5, '...', totalPages];
            }
            if (currentPage >= totalPages - 2) {
              return [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
            }
            return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
          };

          return getPageNumbers().map((pageNumber, i) => {
            if (pageNumber === '...') {
              return (
                <li key={`ellipsis-${i}`} className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              );
            }
            return (
              <li
                key={i}
                className={`page-item ${
                  currentPage === pageNumber ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(pageNumber)}
                >
                  {pageNumber}
                </button>
              </li>
            );
          });
        })()}

        {/* Next button */}
        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() =>
              setCurrentPage(Math.min(totalPages, currentPage + 1))
            }
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </li>
      </ul>
    </div>
  );
};

export default TablePagination;
